import { createFileRoute } from '@tanstack/react-router'
import CommissionPayslips from '@/features/commission-payslips'

export const Route = createFileRoute('/_authenticated/commission-payslips/')({
  component: CommissionPayslips,
})
